import { t } from 'src/boot/i18n';
export default function useValidators() {
  function required(val: unknown) {
    console.log({ val });

    if (!val) return t('PLEASE_ENTER_A_VALUE');
    return !isNaN(val as number)
      ? !!val || t('PLEASE_ENTER_A_VALUE')
      : (typeof val === 'string' && val.length > 0) ||
          t('PLEASE_ENTER_A_VALUE');
  }

  function email(
    val: string,
    rules: { email: (arg0: string) => boolean | string },
  ) {
    return rules.email(val) || t('PLEASE_ENTER_A_VALID_EMAIL_ADDRESS');
  }

  function mobile(val: string) {
    return /^[0-9]{10}$/.test(val) || t('MOBILE_NUMBER_10_DIGITS');
  }

  function min(val: string, min: number) {
    return (val && val.length >= min) || `${t('MIN_CHARACTERS')} ${min}`;
  }

  function max(val: string, max: number) {
    return val.length <= max || `${t('MAX_CHARACTERS')} ${max}`;
  }

  function positiveNumber(val: number) {
    return val > 0 || t('INVALID_VALUE');
  }

  function digitsOnly(val: string) {
    return /^[0-9]+$/.test(val) || t('DIGITS_ONLY');
  }

  function namePattern(val: string) {
    // Allow Latin, Cyrillic, Hebrew, hyphens, apostrophes, and spaces
    return (
      /^[a-zA-Zа-яА-ЯґҐєЄіІїЇ\u0590-\u05FF\s'-]+$/.test(val) ||
      t('INVALID_NAME_FORMAT')
    );
  }

  return {
    required,
    email,
    mobile,
    min,
    max,
    positiveNumber,
    digitsOnly,
    namePattern,
  };
}
